import { AuthConstant } from '../constants'

const AuthActions = {
  authenticate,
  tokenExpired,
  checkingRedirection
}

function authenticate (payload) {
  return {
    type: AuthConstant.AUTHENTICATE,
    payload
  };
}

function tokenExpired (payload) {
  return {
    type: AuthConstant.TOKEN_EXPIRED,
    payload: { token_expired: payload }
  };
}

function checkingRedirection (payload) {
  return {
    type: AuthConstant.CHECKING_REDIRECTION,
    payload: { checking_redirection: payload }
  };
}

export default AuthActions
